module.exports = __webpack_public_path__ + "img/mapHeadBg.3572656b.png";